import { Component, Input, OnInit } from '@angular/core';
import { SpAuthService } from 'app/core/services/utility-services/auth.service';
import { UserContext } from 'app/core';
import { UserContextService } from 'app/core/services/user-context.service';
import { WellKnownRoutes } from 'app/core/enums/well-known-routes';
import { clientClassObj, NgClassObj } from '@shared/utils';

@Component({
  selector: 'sp-nav-dropdown',
  template: `
    <div *ngIf="userContext$ | async as userContext" class="dropdown-container">
      <div class="avatar-container" [ngClass]="clientClasses">
        <i class="fa-solid fa-circle-user fa-2x"></i>
        <div class="info-container">
          <h5 class="info-container-name">{{ userContext.employeeName }}</h5>
          <p class="info-container-client">
            <small>{{ userContext.companyName }}</small>
          </p>
        </div>
        <i class="far fa-chevron-down fa-sm caret"></i>
      </div>
      <ul id="dropdown-nav" class="dropdown-nav">
        <a routerLink="{{ route.Profile }}">
          <li>Profile</li>
        </a>
        <a routerLink="{{ route.AccountManagement }}">
          <li>Manage Account</li>
        </a>
        <ng-container *ngIf="isAuthenticated$ | async as isAuthenticated">
          <a *ngIf="isAuthenticated" (click)="logout()">
            <li>Log Out</li>
          </a>
          <a *ngIf="!isAuthenticated" (click)="loginWithRedirect()">
            <li>Log In</li>
          </a></ng-container
        >
      </ul>
    </div>
  `,
  styleUrls: ['./dropdown.component.scss'],
})
export class NavDropdownComponent implements OnInit {
  route = WellKnownRoutes;
  isAuthenticated$ = this.authService.isAuthenticated$;

  userContext$ = this.userContextService.userContext$;

  clientClasses: NgClassObj = {};

  @Input() userContext: UserContext;

  constructor(private authService: SpAuthService, private userContextService: UserContextService) {}

  ngOnInit(): void {
    this.clientClasses = Object.assign(
      this.clientClasses,
      clientClassObj(this.userContext.programCode)
    );
  }

  logout() {
    this.authService.logout();
  }

  loginWithRedirect() {
    this.authService.loginWithRedirect();
  }
}
